var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OvDocuments',{attrs:{"title":"Ladda upp filer för överlåtaren","computed-documents-groups":_vm.computedDocumentsGroups,"category-type":"transferor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }